import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import TabPanel from "../components/TabPanel";
import ChangePasswordForm from "../components/settings/ChangePasswordForm";
import ChangeAgentForm from "../components/settings/ChangeAgentForm";
import ChangeUserDataForm from "../components/settings/ChangeUserDataForm";

const SettingsPage = () => {
    const [activeTab, setActiveTab] = useState(0);

    const handleChange = (_, newValue) => {
        setActiveTab(newValue);
    };

    const a11yProps = (index) => {
        return {
            id: `tab-${index}`,
            "aria-controls": `tabpanel-${index}`,
        };
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Box
                variant="h4"
                sx={{
                    width: "150",
                    color: "#333",
                    fontSize: "24px",
                    fontWeight: "500",
                    margin: "10px 15px 30px 15px",
                }}
            >
                Configure seu Agente
                <Box
                    variant="div"
                    sx={{
                        fontSize: "13px",
                        fontWeight: 400,
                        pr: "10px",
                    }}
                >
                    Deixe seu agente com a cara da sua empresa!
                </Box>
            </Box>

            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    marginTop: "24px",
                }}
            >
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="settings tabs"
                    sx={{ textTransform: "none" }}
                >
                    <Tab
                        label="Agente"
                        sx={{ textTransform: "none" }}
                        {...a11yProps(0)}
                    />
                    <Tab
                        label="Meus Dados"
                        sx={{ textTransform: "none" }}
                        {...a11yProps(1)}
                    />
                    <Tab
                        label="Alterar Senha"
                        sx={{ textTransform: "none" }}
                        {...a11yProps(2)}
                    />
                </Tabs>
            </Box>

            <TabPanel value={activeTab} index={0}>
                <ChangeAgentForm />
            </TabPanel>
            <TabPanel value={activeTab} index={1}>
                <ChangeUserDataForm />
            </TabPanel>
            <TabPanel value={activeTab} index={2}>
                <ChangePasswordForm />
            </TabPanel>
        </Box>
    );
};

export default SettingsPage;
